import * as Sentry from "@sentry/vue";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (id) {
  const routeLang = useRouteLang();

  try {
    return await $apiFetch(API_ENDPOINTS.CATALOGUE_POST_ID, {
      method: 'GET',
      path: { id },
      params: {
        locale: routeLang.locale.value
      }
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
}
